import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import ScrollContainer from 'react-indiana-drag-scroll';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

import { PORTFOLIO_LIST_HEADER } from '@constants/tableheader';

/** 조합 관리 > 상세 > 포트폴리오사 목록 스켈레톤 */
const PortfolioListSkeleton = () => {
  const tableData = useMemo(
    () =>
      Array.from({ length: 10 })?.map((d: any, i: number) => ({
        id: i,
        no: (
          <div css={items}>
            <Skeleton variant="text" width={20} />
          </div>
        ),
        name: (
          <div css={items}>
            <Skeleton variant="text" width={100} />
          </div>
        ),
        serviceName: (
          <div css={items}>
            <Skeleton variant="text" width={120} />
          </div>
        ),
        lastInvestDate: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        totalInvestmentCount: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        shareholdingCount: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        totalInvestmentAmount: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        lastCorporateValue: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        corporateValue: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        accumulatedIssuanceQuantity: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        equityValue: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        traffic: (
          <div css={items}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        sales: (
          <div css={items}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        employee: (
          <div css={items}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        runway: (
          <div css={items}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div
        css={[
          titleStyle,
          { justifyContent: 'space-between', alignItems: 'center' },
        ]}
      >
        <Skeleton variant="text" width={180} />
        <Skeleton
          variant="rectangular"
          width={88}
          height={34}
          sx={{ borderRadius: '5px' }}
        />
      </div>
      <ScrollContainer css={tableWrap} hideScrollbars={false}>
        <Table header={PORTFOLIO_LIST_HEADER} data={tableData} />
      </ScrollContainer>
    </>
  );
};

export default PortfolioListSkeleton;

const tableWrap = css`
  border-radius: 5px 5px 0 0;
  overflow-x: auto;
  padding: 1px;
  &::-webkit-scrollbar {
    width: 4px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.gray4};
    height: 30%;
  }
  &::-webkit-scrollbar-track {
    background: ${palette.gray3};
  }

  table {
    width: calc(1920px - 250px - 82px);
  }
`;

const items = css`
  display: flex;
  justify-content: center;
`;
